import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'
import { PHONES, DESKTOPS } from 'styles/media-queries'

const { unit, half } = measures

export const filtersWrapper = css`
  ${PHONES} {
    display: flex;
    flex-direction: column;
  }
`

export const phoneSpace = css`
  flex: 1;
  ${PHONES} {
    margin-bottom: ${unit * 4}px;
  }
`

export const wrapSearch = css`
  ${PHONES} {
    padding-left: ${unit}px;
  }
`

export const tooltip = css`
  display: none;
  ${DESKTOPS} {
    position: relative;
    display: inline-block;

    .helpIcon {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${colors.white100};
      color: ${colors.black100};
      height: ${unit * 4}px;
      width: ${unit * 4}px;
      border-radius: ${unit * 2}px;
      margin-left: ${unit}px;
      margin-top: ${half}px;
    }

    .tooltiptext {
      margin-top: ${half}px;
      visibility: hidden;
      width: ${unit * 100}px;
      border-radius: ${unit}px;
      background-color: ${colors.black80};
      border: 1px solid ${colors.white100};
      color: ${colors.white100};
      text-align: center;
      border-radius: 6px;
      padding: ${unit}px ${unit}px;
      font-weight: bold;

      position: absolute;
      z-index: 1;
    }

    .tooltiptext--item {
      display: block;
    }

    &:hover .tooltiptext {
      visibility: visible;
    }

    &:hover {
      color: white;
    }
  }
`
